import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import authorsTableData from "layouts/karkun-management/data";
import { useEffect, useState, useRef } from "react";
import karkunService from "services/karkun-service";
import Notification from "examples/Notifications";
import MDButton from "ui/MDButton";
import Papa from "papaparse"; // CSV Parsing
import { Icon, TextField } from "@mui/material";
import centerService from "services/center-service";
import { PermissionButton } from "layouts/common/buttons";
import { AddButton } from "layouts/common/buttons";

const KarkunManagement = () => {
  const [karkuns, setKarkuns] = useState([]);
  const [notification, setNotification] = useState(null);
  const fileInputRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedKarkuns, setSelectedKarkuns] = useState([]);
  const [centerName, setCenterName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getKarkuns();
  }, []);

  const getKarkuns = async () => {
    try {
      const [karkunData, centerData] = await Promise.all([
        karkunService.getAll(),
        centerService.getAll(), // Get all centers
      ]);

      if (karkunData.success && centerData.success) {
        const centersMap = {};
        centerData.centers.forEach(center => {
          centersMap[center.id] = center.name;
        });

        const karkunsWithCenterNames = karkunData.karkuns.map(karkun => {
          const centerName = centersMap[karkun.center] || 'N/A';
          return { ...karkun, centerName };
        });

        setKarkuns(karkunsWithCenterNames);
      }
    } catch (error) {
      console.error("Error fetching karkuns or centers:", error);
    } finally {
      setLoading(false);
    }
  };




  useEffect(() => {
    if (searchQuery) {
      const filtered = karkuns.filter((karkun) => {
        const name = karkun.name?.toLowerCase() || '';
        const centerTitle = karkun.centertitle?.toLowerCase() || '';
        const karkunId = karkun.karkunid?.toLowerCase() || karkun.karkunid?.toString() || '';

        return (
          name.includes(searchQuery.toLowerCase()) ||
          karkunId.includes(searchQuery) ||
          centerTitle.includes(searchQuery.toLowerCase())
        );
      });
      setSelectedKarkuns(filtered);
    } else {
      setSelectedKarkuns(karkuns);
    }
  }, [searchQuery, karkuns]);






  // Function to trigger file input
  const handleImportClick = () => {
    fileInputRef.current.click();
  };

  // Function to handle file selection
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    console.log("Selected file:", file);
    if (!file) return;

    // Create a new FormData instance and append the file
    const formData = new FormData();
    formData.append("file", file); // The key must match the one used in multer.single('file')

    try {
      const response = await karkunService.import(formData); // Pass formData to the backend
      if (response.success) {
        setNotification({ type: "success", message: "Karkuns imported successfully!" });
        getKarkuns();
      } else {
        setNotification({ type: "error", message: response.message });
      }
    } catch (error) {
      console.error("Error during import:", error);
      setNotification({ type: "error", message: "Import failed. Please try again." });
    }
  };



  const { columns, rows } = authorsTableData(selectedKarkuns);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info"
                display="flex" justifyContent="space-between" alignItems="center">
                <MDTypography variant="h6" color="white"> Karkuns </MDTypography>
                <MDBox display="flex" alignItems="center" width="20%" justifyContent="space-evenly" class="mobile-buttons">
                  <PermissionButton permissions={["karkun:create"]}>
                    <AddButton link="/karkuns/create" />
                  </PermissionButton>
                  <PermissionButton permissions={["karkun:create"]}>
                    <MDButton onClick={handleImportClick}>
                      <Icon sx={{ fontWeight: "bold" }}>import_export</Icon>
                      &nbsp;
                      Import</MDButton>
                  </PermissionButton>

                  <input type="file" ref={fileInputRef} style={{ display: "none" }} accept=".csv" onChange={handleFileUpload} />
                </MDBox>
              </MDBox>
              <MDBox mt={3} display="block" alignItems="center" p={2}>
                <TextField
                  label="Search"
                  variant="outlined"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  fullWidth
                  sx={{ maxWidth: 300 }}
                />
              </MDBox>
              <Notification notification={notification} setNotification={setNotification} />
              <MDBox pt={3}>
                <DataTable table={{ columns, rows }} isSorted={true} entriesPerPage={false} showTotalEntries={false} noEndBorder />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default KarkunManagement;
